import { Link } from "gatsby";
const Services = () => (
  <div className="pageWrapper">
    <main className="mainHolder labsMainHolder">
      <section style={{
        backgroundImage: `url(${"./assets/images/"})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
        className="siteSection hero-sec for-workpage bg-pattern-6">
        <div className="container">
          <div className="siteSection--body content-body text-center">
            <div className="row">
              <div className="col text-center">
                <h1 className="header-title lg cd-headline slide">
                  <span>Services - </span>
                  <span className="cd-words-wrapper">
                    <b className="is-visible highlight">BizDamn</b>
                    <b className="highlight">Wordpress</b>
                    <b className="highlight">Web App</b>
                    <b className="highlight">Website</b>
                  </span>
                </h1>
                <p style={{ fontSize: "2rem" }} className=" info md lg ">We create Super Rich Experiences</p>
                <div className="">
                  <Link to="/consultancy" className="btn btn-outline-primary">Free Website Audit</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*Wordpress Development  */}
      <section className="siteSection with-bg b-spaced lab-product hackr-item">
        <div className="bgGradient hackr-blue radial-tl gradient-sec"></div>
        <div className="siteSection--body">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 left">
                <h2 className="header-title"><Link to="/web-development-services" >
                  <span style={{ backgroundColor: '#21759b' }} className="text-bg-style">Wordpress Development</span></Link></h2>
                {/* Faq */}
                <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WordpressOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        What are Types of Wordpress Websites?
                      </button>
                    </h2>
                    <div
                      id="WordpressOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <Link to='/website-packages'> <li>Ecommerce Website</li></Link>
                          <Link to='/website-packages'> <li>Business Website</li></Link>
                          <Link to='/website-packages'> <li>Blog or Personal Website</li></Link>
                          <Link to='/website-packages'> <li>Portfolio Website</li></Link>
                          <Link to='/website-packages'> <li>Book Launch Website</li></Link>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WordpressTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        How much time does WordPress website development take?
                      </button>
                    </h2>
                    <div
                      id="WordpressTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        There is no accurate answer,it depends on the type of website which you want to develop.
                        <br /><br />
                        Ecommerce WordPress website can take 17-20 days.
                        <br /><br />
                        A Buusiness WordPress website will take 6-8 days.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WordpressThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        How will I get regular updates on my wordpress development project?
                      </button>
                    </h2>
                    <div
                      id="WordpressThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Our Project Delivery manager will remain in direct touch with you to provide regular updates on the progress of the project.
                        <br /><br />
                        You can opt for any medium of communication with us.
                        <br /><br />
                        You will be provided a temporary link to see your project progress and details at any time😊
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WordpressFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        How much does WordPress website development cost?
                      </button>
                    </h2>
                    <div
                      id="WordpressFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        You can cheack all <Link to='/website-packages'>Our Pacakges Here</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt--20">
                  <Link to="/web-development-services" className="btn btn-sm btn-outline-wordpress" >Know More</Link>
                </div>
              </div>
              <div className="col-md-6 right d-flex justify-content-center align-items-center">

                <lottie-player
                  src="https://assets5.lottiefiles.com/packages/lf20_rqcjx8hr.json"
                  background="transparent"
                  speed="1"
                  style={{ width: '90%'}}
                  loop
                  autoplay
                ></lottie-player>
              </div>
            </div>
          </div>
        </div>
      </section>




      {/* Custom Website Development*/}
      <section className="siteSection with-bg b-spaced lab-product spectrum-item bg-pattern-spectrum">
        <div className="bgGradient spectrum-green-lab radial-tl gradient-sec"></div>
        <div className="siteSection--body">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 left d-flex justify-content-center align-items-center">
                <lottie-player
                  src="https://assets1.lottiefiles.com/packages/lf20_qq5qecip.json"
                  background="transparent"
                  speed="1"
                  style={{ width: '100%'}}
                  loop
                  autoplay
                ></lottie-player>
              </div>
              <div className="col-md-6 right">
                <h2 className="header-title">
                  <Link to="/web-development-services" >
                    <span style={{ backgroundColor: '#38B6FF' }} className="text-bg-style">Custom Website Development</span>
                  </Link></h2>

                {/* Faq */}

                <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#CustomWebsiteOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        What technologies do you work on for web development?
                      </button>
                    </h2>
                    <div
                      id="CustomWebsiteOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <Link to="/technologies/#web-development">Top Notch Technologies we are versed with</Link>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#CustomWebsiteTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        Will my website be optimized for search engines like Google?
                      </button>
                    </h2>
                    <div
                      id="CustomWebsiteTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Be it a start-up or scale-up, enterprise or corporate website, our designs are compliant with SEO guidelines. <br />
                        Let us know and we will be happy to explain the details.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#CustomWebsiteThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        How does the Web Development Process work?
                      </button>
                    </h2>
                    <div
                      id="CustomWebsiteThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Here’s a run-down of the phases involved in our web development process:
                        <ul>
                          <li>Consultation & Requirement Gathering</li>
                          <li>Establish a Project Plan</li>
                          <li>Design of Website Mock-ups</li>
                          <li>Create Site Architecture and Database</li>
                          <li>Website Building</li>
                          <li>Website Testing & Launch</li>
                          <li>Support & Maintenance</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>








                <div className="mt--20">
                  <Link to="/web-development-services" className="btn btn-sm btn-outline-primary">
                    Know More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Web Designing */}
      <section className="siteSection with-bg b-spaced lab-product vectors-item">
        <div className="bgGradient vectors-orange radial-tl gradient-sec"></div>
        <div className="siteSection--body">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 left">
                <h2 className="header-title"><Link to="/web-development-services" >
                  <span style={{ backgroundColor: '#FFBD37' }} className="text-bg-style">Website Design</span></Link></h2>
                {/* Faq */}

                <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#DesignOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        I have aready finalized my website design(Mockup).Can you Build?
                      </button>
                    </h2>
                    <div
                      id="DesignOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Yes sure, we will love to follow your Designs
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#DesignTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        What tools do you use for Designing?
                      </button>
                    </h2>
                    <div
                      id="DesignTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <Link to="/technologies/#design"> Check out All Tools we use to build professional designs</Link>
                      </div>
                    </div>
                  </div>

                </div>


                <div className="mt--20">
                  <Link to="/web-development-services" className="btn btn-sm btn-outline-vectors">Know More</Link>
                </div>
              </div>
              <div className="col-md-6 right d-flex justify-content-center align-items-center">
                <lottie-player
                  src="https://assets5.lottiefiles.com/packages/lf20_hi95bvmx/WebdesignBg.json"
                  background="transparent"
                  speed="1"
                  style={{ width: '100%'}}
                  loop
                  autoplay
                ></lottie-player>
              </div>
            </div>
          </div>
        </div>
      </section>





      {/* Website Maintainance*/}
      <section className="siteSection with-bg b-spaced lab-product tfl-item bg-pattern-tfl">
        <div className="bgGradient tfl-purple-lab radial-tl gradient-sec"></div>
        <div className="siteSection--body">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 left d-flex justify-content-center align-items-center">
                <lottie-player
                  src="https://assets2.lottiefiles.com/packages/lf20_akio2kni.json"
                  background="transparent"
                  speed="1"
                  style={{ width: '85%'}}
                  loop
                  autoplay
                ></lottie-player>
              </div>
              <div className="col-md-6 right">
                <h2 className="header-title"><Link to="/web-development-services" >
                  <span style={{ backgroundColor: '#8969ED' }} className="text-bg-style"> Website Annual Maintainance </span></Link></h2>
                {/* Faq */}
                <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WebsiteMaintainanceOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        What is Website Maintenance?
                      </button>
                    </h2>
                    <div
                      id="WebsiteMaintainanceOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Regularly checking your Website for mistakes & issues in order to keep ir releavent and updated.<br />
                        This needs to be done on a consistent basis to keep your website healthy, strengthen your SEO as well as Google Ranking and encourage the continued growth of traffic.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#WebsiteMaintainanceTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        Why Website Maintenance services is Necessary?
                      </button>
                    </h2>
                    <div
                      id="WebsiteMaintainanceTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-mdb-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>To keep your Website Running</li>
                          <li>To acquire new customers</li>
                          <li>To maintain your credibility</li>
                          <li>To get higher search engine rankings</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>










                <div className="mt--20">
                  <Link to="/web-development-services" className="btn btn-sm btn-outline-tfl">Know More</Link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section className="siteSection with-bg work-sec mt--0">
        <div className="bgGradient blue full"></div>
        <h4 className="headerTagText">Take <br className="d-sm-none" />Business
          <br className="d-sm-none" />  Online</h4>


        <section className="siteSection labs-design-sec b-spaced">
          <div className="container">

            <div className="row text-center">
              <div className="col">
                <div className="siteSection--header">
                  <h2 className="header-title text-primary">Have a Tight Budget?</h2>
                  <p className="header-description info md">Don't Worry, Your every penny <br className="d-none d-sm-inline" />will be a Worth!!</p>
                </div>

              </div>
              <div className="mt-4">
                <Link to="/website-packages" className="btn btn-outline-primary">Choose a Package Now</Link>
              </div>
            </div>
          </div>
        </section>


      </section>
    </main>
  </div>


);
export default Services;
